/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import * as Yup from 'yup';
import _ from 'lodash';
import { getLocalizedStrings } from '../misc';

const {
  USERS: {
    FORM: {
      VALIDATION_MESSAGE: { REQUIRED, EMAIL, NUMERIC, ALPHANUMERIC, MIN, MAX }
    }
  }
} = getLocalizedStrings();

const isOutletRequired = (role, channel) =>
  ![1, 3, 6, 11].includes(+role) &&
  ![7, 89, 90, 91, 92, 99].includes(+_.get(channel, '0.id', ''));

const isCpmsRequired = (role, channel) =>
  ![1, 3, 6, 11].includes(+role) &&
  ![7, 89, 90, 91, 92, 99].includes(+_.get(channel, '0.id', ''));

const isXidRequired = (role, channel) =>
  [1, 3, 6, 11].includes(+role) ||
  [7, 89, 90, 91, 92, 99].includes(+_.get(channel, '0.id', ''));

const isDealershipRequired = (role, channel, multiChannels) => {
  const valueChannel =
    +role === 11 ? multiChannels : [+_.get(channel, '0.id', '')];
  return [2, 7, 11].includes(+role) && valueChannel && valueChannel.includes(9);
};

const isChannelRequired = role => ![1, 2, 6].includes(+role);

const isStoreCodeRequired = (role, channel, multiChannels) => {
  const valueChannel =
    +role === 11 ? multiChannels : [+_.get(channel, '0.id', '')];
  return (
    [2, 7, 11].includes(+role) && valueChannel && valueChannel.includes(99)
  );
};

const validationJSON = Yup.object().shape({
  roleId: Yup.mixed().required(() => {
    return REQUIRED;
  }),
  firstName: Yup.string().required(() => {
    return REQUIRED;
  }),
  lastName: Yup.string().required(() => {
    return REQUIRED;
  }),
  email: Yup.string()
    .email(() => {
      return EMAIL;
    })
    .required(() => {
      return REQUIRED;
    }),
  province: Yup.mixed().when('roleId', {
    is: val => val !== 11,
    then: Yup.string().required(REQUIRED),
    otherwise: Yup.string()
  }),
  provinceIds: Yup.mixed().when('roleId', {
    is: '11',
    then: Yup.array()
      .of(Yup.number())
      .required(REQUIRED)
      .min(1),
    otherwise: Yup.array()
  }),
  contactNumber: Yup.string()
    .required(() => {
      return REQUIRED;
    })
    .matches(/^[0-9]+$/, () => {
      return NUMERIC;
    }),
  channelId: Yup.mixed().when('roleId', {
    is: isChannelRequired,
    then: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string(),
          label: Yup.string()
        })
      )
      .required(() => REQUIRED)
  }),
  channelIds: Yup.mixed().when('roleId', {
    is: val => val === 11,
    then: Yup.array()
      .of(Yup.number())
      .required(REQUIRED)
      .min(1),
    otherwise: Yup.array()
  }),
  outlet: Yup.string().when(['roleId', 'channelId'], {
    is: isOutletRequired,
    then: Yup.string()
      .required(() => {
        return REQUIRED;
      })
      .matches(/^[a-zA-Z0-9]+$/, () => {
        return ALPHANUMERIC;
      })
      .min(10, () => {
        return MIN['10'];
      })
      .max(10, () => {
        return MAX['10'];
      }),
    otherwise: Yup.string()
  }),
  cpmsId: Yup.string().when(['roleId', 'channelId'], {
    is: isCpmsRequired,
    then: Yup.string()
      .required(() => {
        return REQUIRED;
      })
      .min(4, () => {
        return MIN['4'];
      })
      .max(4, () => {
        return MAX['4'];
      }),
    otherwise: Yup.string()
  }),
  storeCode: Yup.string().when(['roleId', 'channelId', 'channelIds'], {
    is: isStoreCodeRequired,
    then: Yup.string()
      .required(() => {
        return REQUIRED;
      })
      .min(5, () => {
        return MIN['5'];
      })
      .max(5, () => {
        return MAX['5'];
      }),
    otherwise: Yup.string()
  }),
  xid: Yup.string().when(['roleId', 'channelId'], {
    is: isXidRequired,
    then: Yup.string()
      .required(() => {
        return REQUIRED;
      })
      .min(7, () => {
        return MIN['7'];
      })
      .max(7, () => {
        return MAX['7'];
      }),
    otherwise: Yup.string()
  }),
  dealership: Yup.string().when(['roleId', 'channelId', 'channelIds'], {
    is: isDealershipRequired,
    then: Yup.string().required(() => {
      return REQUIRED;
    }),
    otherwise: Yup.string()
  }),
  channelOrgCode: Yup.string().when(['roleId', 'channelId', 'channelIds'], {
    is: isDealershipRequired,
    then: Yup.string()
      .required(() => {
        return REQUIRED;
      })
      .min(5, () => {
        return MIN['5'];
      })
      .max(5, () => {
        return MAX['5'];
      }),
    otherwise: Yup.string()
  }),
  salesManager: Yup.string().when('roleId', {
    is: '1',
    then: Yup.string(),
    otherwise: Yup.string().required(() => {
      return REQUIRED;
    })
  }),
  salesManagerEmail: Yup.string().when('roleId', {
    is: '1',
    then: Yup.string(),
    otherwise: Yup.string()
      .required(() => {
        return REQUIRED;
      })
      .email(() => {
        return EMAIL;
      })
  })
});

export default validationJSON;
